import { defineComponent as _defineComponent } from 'vue'
import { useDocuments } from '@/store/useDocuments';
import { ref, watch } from 'vue';

type Props = {
    docRef: string
}

export default /*@__PURE__*/_defineComponent({
  __name: 'vaccine-download',
  props: {
    docRef: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const documents = useDocuments();

const props = __props;

const imgurl = ref<string | null>(null);
const error = ref<string | null>(null);

watch(() => props.docRef, async r => {
    try {
        const url = await documents.getUrl(r);
        if (!url) throw new Error("Can't find doc");
        imgurl.value = url;
    } catch (e) {
        console.error(e);
        error.value = (e as Error).message;
    }
}, { immediate: true });

const __returned__ = { documents, props, imgurl, error, get useDocuments() { return useDocuments }, ref, watch }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})